export class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.initialize()
  }

  initialize() {
    // Get the main gallery and thumbnail buttons
    this.mainGallery = this.querySelector('[data-role="main-gallery"]')
    this.thumbnailButtons = this.querySelectorAll('[data-role="thumbnail-button"]')

    if (!this.mainGallery || !this.thumbnailButtons) {
      return
    }

    // Add event listeners to thumbnail buttons
    this.thumbnailButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const index = button.getAttribute('data-index')
        if (index) {
          this.goToSlide(parseInt(index) - 1) // Flickity uses 0-based indexing
        }
      })
    })

    // Wait for Flickity to be initialized
    setTimeout(() => {
      this.setupFlickityListener()
    }, 100)
  }

  setupFlickityListener() {
    if (!this.mainGallery) return

    // Try to access the Flickity instance
    const flickityInstance = this.mainGallery.flickity

    if (flickityInstance) {
      // Listen for slide changes using Flickity's event system
      flickityInstance.on('select', (index) => {
        this.updateActiveThumbnail(index)
      })
    } else {
      // Fallback to DOM event listener
      this.mainGallery.addEventListener('change.flickity', (event) => {
        this.updateActiveThumbnail(event.detail?.index || 0)
      })
    }

    // Initialize active state
    this.updateActiveThumbnail(0)
  }

  goToSlide(index) {
    if (this.mainGallery) {
      const flickityInstance = this.mainGallery.flickity
      if (flickityInstance) {
        flickityInstance.select(index)
      }
    }
  }

  updateActiveThumbnail(activeIndex) {
    if (!this.thumbnailButtons) return

    this.thumbnailButtons.forEach((button, index) => {
      const isActive = index === activeIndex
      button.setAttribute('data-active', isActive.toString())

      if (isActive) {
        button.classList.add('border-primary')
        button.classList.remove('border-neutral-medium')
      } else {
        button.classList.remove('border-primary')
        button.classList.add('border-neutral-medium')
      }
    })
  }

  disconnectedCallback() {
    // Clean up event listeners if needed
    if (this.thumbnailButtons) {
      this.thumbnailButtons.forEach((button) => {
        button.removeEventListener('click', () => {})
      })
    }
  }
}
